import Vue from 'vue'
import Router from 'vue-router'
import Desktop from '@/components/views/Desktop'
import BIMPlatformCommon from '@/components/views/BIMPlatformCommon'
import BIMIssueTrack from '@/components/views/BIMIssueTrack'
import BIMFamilyLibWeb from '@/components/views/BIMFamilyLibWeb'
import CustomerCase from '@/components/views/CustomerCase'
import AboutUs from '@/components/views/AboutUs'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Desktop',
      component: Desktop,
    },
    {
      path: '/BIMPlatformCommon',
      name: 'BIMPlatformCommon',
      component: BIMPlatformCommon
    },
    {
      path: '/BIMIssueTrack',
      name: 'BIMIssueTrack',
      component: BIMIssueTrack
    },
    {
      path: '/BIMFamilyLibWeb',
      name: 'BIMFamilyLibWeb',
      component: BIMFamilyLibWeb
    },
    {
      path: '/CustomerCase',
      name: 'CustomerCase',
      component: CustomerCase
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js